import type { ToolDefinition } from '../../lib/api';
import { HttpToolTestPanel } from './HttpToolTestPanel';
import { LookupToolTestPanel } from './LookupToolTestPanel';

interface ToolTestPanelProps {
  tool: ToolDefinition;
}

export const ToolTestPanel = ({ tool }: ToolTestPanelProps) =>
  tool.execution_kind === 'schema_lookup' ? (
    <LookupToolTestPanel tool={tool} />
  ) : (
    <HttpToolTestPanel tool={tool} />
  );
